import { render, staticRenderFns } from "./OpisBlock.vue?vue&type=template&id=49bc7640&"
import script from "./OpisBlock.vue?vue&type=script&lang=js&"
export * from "./OpisBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports